import PicklistMetadata from "../PicklistMetadata";

// Static picklist sourced from the loaded pick values whose Type is "Rule Type"
// (display = Name, value = Value). Seeded by docs/Schema/rule_picklist_static_data.sql; the
// discriminator lives in PICK_TYPE, matching the Category Term Type convention.
class RuleTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RuleType";
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Rule Type";
        this.useRealm = false;
        this.allowNoSelection = true;
    }
}

export default RuleTypePicklistMetadata;
